export const POST_METHOD = "POST";
export const GET_METHOD = "GET_METHOD";
